import { Link } from "@reusable";
import { IconArrowRight } from "@reusable";
import * as React from 'react';
export default {
  Link,
  IconArrowRight,
  React
};